<template>
  <div class="labeled-vehicles-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <VehiclesList
      ref="vehiclesList"
      :id="inputId"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :vehicle="vehicle"
      :vehicles="vehicles"
      :empty-state-text="emptyStateText"
      :select-first-vehicle="selectFirstVehicle"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </VehiclesList>
  </div>
</template>

<script>
import VehiclesList from '../vehicles-list';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    label: {
      type: String,
      default: 'Оберіть авто клієнта зі списку',
    },
    placeholder: {
      type: String,
      default: 'Оберіть авто клієнта',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    vehicle: {
      type: [String, Number, null],
      default: null,
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    selectFirstVehicle: {
      type: Boolean,
      default: true,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      inputId: `vehicles-list-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, VehiclesList },
  computed: {
    getVehiclesList() {
      return this.$refs.vehiclesList;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
};
</script>
